export const GlobalFilter = ({filter, setFilter}) => {
    return (
        <div className="ms-2">
            <label className="form-label" htmlFor="globalFilter">Αναζήτηση { ' ' } </label>
            <input id="globalFilter" className="form-control" value={filter || ''} onChange={(e) => setFilter(e.target.value)} />
        </div>
    )
}